export default "__VITE_ASSET__BSAojCtz__"